import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix marker icon issue
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

export default function Map() {
  const locations = [
    { name: "Lahore", lat: 31.5204, lng: 74.3587,count: 100 },
    { name: "Karachi", lat: 24.8607, lng: 67.0011,count: 200 },
    { name: "Islamabad", lat: 33.6844, lng: 73.0479,count: 50 },
  ];

  return (
    <MapContainer
      center={[31.5204, 74.3587]}
      zoom={5}
      style={{ height: "400px", width: "100%" }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      {locations.map((loc, index) => (
        <Marker key={index} position={[loc.lat, loc.lng]}>
          <Popup>{loc.name}-({loc.count})</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}